import { Component, inject } from '@angular/core';
import { BaseClientTaskHistoryComponent } from '../base-client-task-history/base-client-task-history.component';
import { ClientReferralTasksService } from 'app/core/services/client-referral-tasks.service';

import { ClientTaskNavComponent } from '../../components/client-task-nav/client-task-nav.component';
import { ClientTaskHistoryItemListComponent } from '../../components/client-task-history-item-list/client-task-history-item-list.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-client-referral-task-history',
  templateUrl: './client-referral-task-history.component.html',
  styleUrls: ['./client-referral-task-history.component.scss'],
  imports: [ClientTaskNavComponent, ClientTaskHistoryItemListComponent, MatProgressSpinner]
})
export class ClientReferralTaskHistoryComponent extends BaseClientTaskHistoryComponent {
  constructor() {
    const clientTasksService = inject(ClientReferralTasksService);

    super(clientTasksService);
  }
}
